var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "defult",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { label: "代理姓名:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_name", $$v)
                        },
                        expression: "form.search_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-up",
                    attrs: { label: "手机号码:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_phone", $$v)
                        },
                        expression: "form.search_phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", { attrs: { label: "押金月份:" } }, [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "picker-options": _vm.monthOptions,
                          type: "month",
                          placeholder: "选择月份",
                          "value-format": "timestamp",
                        },
                        model: {
                          value: _vm.listQuery.month_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "month_date", $$v)
                          },
                          expression: "listQuery.month_date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "投放场地:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.put_place,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "put_place", $$v)
                          },
                          expression: "listQuery.put_place",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "请选择", value: 0 },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.put_place, function (itme) {
                          return _c("el-option", {
                            attrs: { label: itme.name, value: "" + itme.name },
                          })
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-down",
                    attrs: { label: "手机号码:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_phone", $$v)
                        },
                        expression: "form.search_phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-down",
                    attrs: { label: "代理状态:" },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.activated_status,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "activated_status", $$v)
                          },
                          expression: "listQuery.activated_status",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "有效", value: 1 } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "无效", value: 2 } }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已删除", value: 0 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", "native-type": "submit" } },
                      [
                        _vm._v("查询"),
                        _c("i", {
                          staticClass: "el-icon-search el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery(1)
                          },
                        },
                      },
                      [
                        _vm._v("重置"),
                        _c("i", {
                          staticClass: "el-icon-refresh el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.outTab("list_table", "代理记录")
                          },
                        },
                      },
                      [
                        _vm._v("导出"),
                        _c("i", { staticClass: "el-icon-male el-icon--right" }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.showDialog()
                          },
                        },
                      },
                      [
                        _vm._v("存量余额总览"),
                        _c("i", { staticClass: "el-icon-male el-icon--right" }),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "p-5" },
        [
          _c(
            "div",
            { staticClass: "bg-white" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "list_table",
                  staticClass: "ptd-5",
                  attrs: {
                    id: "list_table",
                    data: _vm.list,
                    "element-loading-text": "Loading",
                    stripe: "",
                    "highlight-current-row": "",
                    "max-height": _vm.tableMaxH,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "代理信息" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                staticClass: "fs-c1",
                                attrs: {
                                  href:
                                    "/userManage/user_order?son_id=" +
                                    scope.row.aid,
                                  target: "_blank",
                                  type: "primary",
                                },
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(scope.row.name) +
                                      "(" +
                                      _vm._s(scope.row.agent_name) +
                                      _vm._s(scope.row.aid) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.checkHidRole("agentPclbsjhxs")
                                  ? _c("div", [
                                      _vm._v(
                                        "账户：" + _vm._s(scope.row.phone)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "登录：" +
                                      _vm._s(
                                        _vm.parseTime(
                                          scope.row.login_time,
                                          "{y}-{m}-{d} {h}:{i}"
                                        )
                                      )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "用户" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex align-center" },
                              [
                                _c("el-avatar", {
                                  attrs: {
                                    size: "small",
                                    src: scope.row.avatar,
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex1 ml-5" }, [
                                  _vm._v(_vm._s(scope.row.nick_name)),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  !_vm.checkRoles(["terminal"])
                    ? _c("el-table-column", {
                        attrs: { label: "用户押金总额" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "cursor" }, [
                                    _vm._v(
                                      _vm._s(scope.row.user_deposit) + "元"
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4023065067
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkRoles(["partner"])
                    ? _c("el-table-column", {
                        attrs: { label: "投放天数" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.todays(scope.row.add_date)) +
                                      "天\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2728443467
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "投放场地" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.put_place || "无") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "开户时间" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.parseTime(
                                    scope.row.add_date,
                                    "{y}-{m}-{d}"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "存量余额" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showBalanceDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex justify-center" },
                [
                  _c("pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.listQuery.page_num > 0,
                        expression: "listQuery.page_num > 0",
                      },
                    ],
                    attrs: {
                      page: _vm.listQuery.start,
                      limit: _vm.listQuery.limit,
                      "page-count": _vm.listQuery.page_num,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.listQuery, "start", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.listQuery, "limit", $event)
                      },
                      pagination: _vm.getList,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("editwith", { ref: "editwith", attrs: { type: 1 } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.overviewDialogVisible,
            width: "1290px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.overviewDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingRechargeData,
                  expression: "loadingRechargeData",
                },
              ],
              staticStyle: {
                width: "100%",
                height: "300px",
                "margin-bottom": "20px",
              },
              attrs: { "element-loading-text": "Loading..." },
            },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "20px" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd",
                      "picker-options": _vm.pickerOptions,
                    },
                    on: { change: _vm.handleDateChange },
                    model: {
                      value: _vm.rechargeDateRange,
                      callback: function ($$v) {
                        _vm.rechargeDateRange = $$v
                      },
                      expression: "rechargeDateRange",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.refreshRechargeChart },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                ref: "rechargeChartContainer",
                staticStyle: { width: "100%", height: "calc(100% - 60px)" },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "explanation-card", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "card-title" }, [
                    _vm._v("各项目存量余额-统计说明"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "12px",
                    color: "#999",
                    "margin-top": "-15px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _vm._v(
                    "\n      统计时段内的存量余额为对应时段的支付金额-消费金额=剩余余额\n    "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                height: "1px",
                background:
                  "linear-gradient(to right, transparent, #ccc, transparent)",
                margin: "20px 0",
                position: "relative",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "-10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    background: "white",
                    padding: "0 15px",
                    color: "#666",
                    "font-size": "14px",
                  },
                },
                [_vm._v("\n        存量余额总览\n      ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingOverviewData,
                  expression: "loadingOverviewData",
                },
              ],
              staticStyle: { width: "100%", height: "400px" },
              attrs: { "element-loading-text": "Loading..." },
            },
            [
              _c("div", {
                ref: "chartContainer",
                staticStyle: { width: "100%", height: "100%" },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "explanation-card", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "card-title" }, [
                    _vm._v("各类存量余额总览-统计说明"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "explanation-content" }, [
                _c("p", [
                  _c("strong", [_vm._v("用户钱包余额：")]),
                  _vm._v("当前"),
                  _c("code", [_vm._v(_vm._s(_vm.explanationContentTitle))]),
                  _vm._v("下的所有用户钱包余额。"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("用户押金余额：")]),
                  _vm._v("当前"),
                  _c("code", [_vm._v(_vm._s(_vm.explanationContentTitle))]),
                  _vm._v("下的所有用户未提现的押金余额。"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("用户提现待审核：")]),
                  _vm._v("当前"),
                  _c("code", [_vm._v(_vm._s(_vm.explanationContentTitle))]),
                  _vm._v("下的所有用户提现待审核总额"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("代理余额：")]),
                  _vm._v("当前"),
                  _c("code", [_vm._v(_vm._s(_vm.explanationContentTitle))]),
                  _vm._v("下的所有代理账户未提现余额"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("商户余额：")]),
                  _vm._v("当前"),
                  _c("code", [_vm._v(_vm._s(_vm.explanationContentTitle))]),
                  _vm._v("下的所有商户账户未提现余额"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("业务员余额：")]),
                  _vm._v("当前"),
                  _c("code", [_vm._v(_vm._s(_vm.explanationContentTitle))]),
                  _vm._v("下的所有业务员账户未提现余额"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("推广余额：")]),
                  _vm._v("当前"),
                  _c("code", [_vm._v(_vm._s(_vm.explanationContentTitle))]),
                  _vm._v("下的所有推广账户未提现余额"),
                ]),
                _vm._v(" "),
                _vm.explanationContentTitle === "平台"
                  ? _c("p", [
                      _c("strong", [_vm._v("合伙人余额：")]),
                      _vm._v("当前"),
                      _c("code", [_vm._v("平台")]),
                      _vm._v(
                        "下的所有合伙人账户未提现余额（仅总后台角色显示）\n          "
                      ),
                    ])
                  : _vm._e(),
                _vm.explanationUserClearAmount == true
                  ? _c("p", [
                      _c("strong", [_vm._v("用户增值金额：")]),
                      _vm._v("当前"),
                      _c("code", [_vm._v("平台")]),
                      _vm._v(
                        "下的所有用户的钱包增值金额的汇总（仅总后台角色显示）\n          "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "note-text" }, [
                _vm._v(
                  "\n        * 注：当前功能只限制了账号角色role_id=1为总后台的账号查询，查询中忽略了账号id=[209, 1003, 1730, 5318, 1731]\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.overviewDialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }